<template>
  <div>
    <div class="vx-col w-full mb-base">
      <vs-card title="Add New Customer" class="p-4 mb-6">
        <div slot="header" class="flex flex-wrap items-center justify-between">
          <div class="flex items-center">
            <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
            <h4 style="margin-left: 10px">Add New Customer</h4>
          </div>
          <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm">Save</vs-button>
        </div>
        <div class="vx-row mt-6">
          <div class="vx-col md:w-1/4 w-full">
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input class="w-full" label="BP ID *" v-model="data.bp_id" />
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input class="w-full" label="Name *" v-model="data.name" />
              </div>
            </div>

            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input class="w-full" label="Address 1 *" v-model="data.address_1" />
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input class="w-full" label="Address 2 *" v-model="data.address_2" />
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input class="w-full" label="PIC " v-model="data.pic" />
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input class="w-full" label="Email " v-model="data.email" />
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/4 w-full">
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input class="w-full" label="Phone " v-model="data.phone" />
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <label for class="vs-input--label">Province</label>
                <vs-select
                    class="selectExample"
                    v-model="province.id"
                    width="100%"
                    autocomplete
                    @input-change="searchProvince($event)"
                    @input="setProvince"
                >
                    <vs-select-item v-for="(item, index) in province.data" :key="index" :value="item.id" :text="item.province"/>
                </vs-select>
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <label for class="vs-input--label">City / District</label>
                <vs-select
                    class="selectExample"
                    v-model="city.id"
                    width="100%"
                    autocomplete
                    @input-change="searchCity($event)"
                    @input="setCity"
                    :disabled="!province.id"
                >
                    <vs-select-item v-for="(item, index) in city.data" :key="index" :value="item.id" :text="item.district"/>
                </vs-select>
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <label for class="vs-input--label">Village / Area</label>
                <vs-select
                    class="selectExample"
                    v-model="data.area_id"
                    width="100%"
                    autocomplete
                    @input-change="searchArea($event)"
                    :disabled="!city.id"
                >
                    <vs-select-item v-for="(item, index) in area.data" :key="index" :value="item.id" :text="item.village"/>
                </vs-select>
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <label for class="vs-input--label">Client</label>
                <vs-select
                    class="selectExample"
                    v-model="data.client_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, client)"
                >
                    <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                </vs-select>
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <label for class="vs-input--label">Client Type</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="data.client_type_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, client_type)"
                >
                    <vs-select-item v-for="(item, index) in client_type.data" :key="index" :value="item.id" :text="item.client_type"/>
                </vs-select>
              </div>
            </div>
          </div>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    vSelect,
    flatPickr
  },
  data() {
    return {
      isLoading: false,
      data: {
        bp_id: "",
        name: "",
        address_1: "",
        address_2: "",
        post_code: "",
        area_id: "",
        sub_area_id: "",
        pic: "",
        phone: "",
        email: "",
        client_type_id: ""
      },
      area: {
          data: [],
          loading: false,
          endpoint: 'master/areas',
          objectKey: 'village'
      },
      client: {
          data: [],
          loading: false,
          endpoint: 'master/clients',
          objectKey: 'client_code'
      },
      client_type: {
          data: [],
          loading: false,
          endpoint: 'master/clienttypes',
          objectKey: 'client_type'
      },
      province: {
          id: null,
          data: [],
          query: '',
      },
      city: {
          id: null,
          data: [],
          query: '',
      }
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    }
  },
  methods: {
    submitForm() {
      this.isLoading = true;
      this.$http
        .post("master/customers/store", this.data)
        .then(res => {
          this.$vs.notify({
            color: "success",
            title: "Saved Successfully",
            iconPack: "feather",
            icon: "icon-check",
            text: "Customer added"
          });
          this.$router.push({ path: "/master/customer" });
        })
        .catch(error => this.handleError(error))
        .then(() => {
          this.isLoading = false;
        });
    },
    back() {
      if (
        this.data.bp_id != "" ||
        this.data.name != "" ||
        this.data.address_1 != "" ||
        this.data.address_2 != "" ||
        this.data.pic != "" ||
        this.data.email != "" ||
        this.data.location != "" ||
        this.data.area_id != "" ||
        this.data.sub_area_id != "" ||
        this.data.client_type_id != "" ||
        this.data.phone != ""
      ) {
        this.$vs.dialog({
          color: "warning",
          title: "Leave Page",
          text: "Changes you made may not be saved?",
          acceptText: "Leave Page",
          accept: () => this.$router.go(-1)
        });
      } else {
        this.$router.go(-1);
      }
    },
    fetchAllData() {
      this.isLoading = true;
      Promise.all([
        this.$http.post("master/areas"),
        this.$http.post("master/clienttypes"),
        this.$http.post("master/clients")
      ])
        .then(
          this.$http.spread((areas, clienttypes, clients) => {
            let provinces = this.$_.uniqBy(areas.data.data, 'province');
            this.province.data = provinces;
            // areas.data.data.map(area => {
            //   if(this.province.data.findIndex(a => a.id == area.id) === -1) {
            //     this.province.data.push(area)
            //   }
            // })

            clienttypes.data.data.map(client_type => {
              if(this.client_type.data.findIndex(a => a.id == client_type.id) === -1) {
                this.client_type.data.push(client_type)
              }
            })

            clients.data.data.map(client => {
              if(this.client.data.findIndex(a => a.id == client.id) === -1) {
                this.client.data.push(client)
              }
            })

            this.isLoading = false;
          })
        )
        .catch(() => {
          this.isLoading = false;
          this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: "Server Error",
            text: "Try again?",
            accept: () => {
              this.fetchAllData();
            },
            cancel: () => this.$router.go(-1),
            acceptText: "Yes",
            cancelText: "No"
          });
        });
    },
    searchProvince(event = null) {
        this.$http.post('master/areas', {
            'province': event ? event.target.value : '',
        })
        .then(res => {
            let provinces = this.$_.uniqBy(res.data.data, 'province');
            this.province.data = provinces;
        });
    },
    setProvince() {
        let province = this.$_.find(this.province.data, { 'id': this.province.id });
        if(province) {
            this.province.query = province.province;
        }

        this.searchCity();
    },
    searchCity(event = null) {
        this.$http.post('master/areas', {
            'district': event ? event.target.value : '',
            'province': this.province.query
        })
        .then(res => {
            let cities = this.$_.uniqBy(res.data.data, 'district');
            this.city.data = cities;
        });
    },
    setCity() {
        let city = this.$_.find(this.city.data, { 'id': this.city.id });
        if(city) {
            this.city.query = city.district;
        }

        this.searchArea();
    },
    searchArea(event = null) {
        this.$http.post('master/areas', {
            'village': event ? event.target.value : '',
            'province': this.province.query,
            'district': this.city.query
        })
        .then(res => {
            this.area.data = res.data.data;
        });
    }
  },
  mounted() {
    this.fetchAllData();
  }
};
</script>